import { ReactElement } from 'react';

interface ConfidenceLegendProps {
  color: string;
  backgroundColor?: string;
  id?: string;
  showBackground?: boolean;
  visibleTag?: boolean;
}

export const ConfidenceLegend = ({
  color,
  backgroundColor = 'transparent',
  id = color,
  showBackground = true,
  visibleTag = true
}: ConfidenceLegendProps): ReactElement => (
  <svg xmlns='http://www.w3.org/2000/svg'>
    <defs>
      <pattern
        id={`confidenLegend${id}${showBackground ? 1 : 0}`}
        width='16'
        height='12'
        patternUnits='userSpaceOnUse'
      >
        {showBackground && (
          <rect width='16' height='12' fill={backgroundColor} opacity={0.25} rx='5' />
        )}
        <circle cx='4' cy='6' r='1.5' fill={color} />
        <circle cx='8' cy='6' r='1.5' fill={color} />
        <circle cx='12' cy='6' r='1.5' fill={color} />
      </pattern>
    </defs>
    {visibleTag && (
      <rect
        width='100%'
        height='100%'
        fill={`url(#confidenLegend${id}${showBackground ? 1 : 0})`}
      />
    )}
  </svg>
);
